// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2cYri","main":"Footer_main__N7qhG","names":"Footer_names__3AM3Q","commentMessage":"Footer_commentMessage__1dXEI","email":"Footer_email__1lnuw"};